import { StatusCodes } from 'http-status-codes';

import { AuthenticateResponse, Account } from '../models';
import { urls } from '../utilities/dataHelpers';
import { mapAccountEntityToAccount } from '../utilities/mappers';
import mediator, { MediatorRequestWithResponse } from '../utilities/mediator';
import {
  handleUserLoggedOut,
  handleGetCapabilities,
  handleUserLoggedIn,
} from './auth';

export const handleUser = (request: MediatorRequestWithResponse<Account>) => {
  request.response = new Promise<Account>((resolve, reject) => {
    mediator
      .request<AuthenticateResponse>('api:invoke', {
        method: 'GET',
        url: urls.api + 'user',
      })
      .then(async (result) => {
        if (result.status === 200) {
          const response = result.data as AuthenticateResponse;

          if (response.user && response.loggedIn) {
            await handleGetCapabilities();
            handleUserLoggedIn(response);
            resolve(mapAccountEntityToAccount(response.user));
          } else {
            handleUserLoggedOut();
            reject(new Error('No user data found'));
          }
        } else {
          handleUserLoggedOut({
            sessionExpired: result.status === StatusCodes.UNAUTHORIZED,
          });
          reject(result);
        }
      })
      .catch((err) => {
        handleUserLoggedOut();
        reject(err);
      });
  });
};

mediator.subscribe('user:getUser', handleUser);
